// Single source of truth for all displayed prices. Change here, nowhere else.
// (See docs/PRICING_RECONCILIATION.md — duplicated literals caused past drift.)
export const PRICING = {
  pro: { monthly: 39, annual: 390 },
  allAccess: { monthly: 129, annual: 1290 },
} as const;

// 12 months billed at 10× the monthly → ~17% off vs paying monthly.
export const ANNUAL_DISCOUNT_PCT = 17;

// Free-tier monthly evaluation allowance. MUST match the backend's
// FREE_EVALUATIONS_PER_MONTH (backend/app/config.py) — display copy that
// hardcoded "5" drifted from the enforced 3 and misled users.
export const FREE_EVALS_PER_MONTH = 3;

// (Founder pricing / FOUNDER100 was retired 2026-07-05 — no launch discount.
// See docs/PRICING_RECONCILIATION.md.)

// "$1,290" / "$129" — USD with thousands separators, no decimals.
export const fmtUSD = (n: number): string => `$${n.toLocaleString("en-US")}`;
